import "../assets/css/invoicedetails.css";
import React, { useEffect, useState, useRef } from "react";
import {
  formatNumberWithCommas,
  parseNumericValue,
} from "../utils/format-number";

const InvoiceDetails = ({
  total,
  currencyType,
  setCurrencyType,
  subTotal,
  taxEnabled,
  setTaxEnabled,
  tax,
  promotionAmount,
  setTax,
  taxAmount,
  discount,
  setDiscount,
  paidAmount,
  setPaidAmount,
  change,
  subTotalMMK,
  subTotalTHB,
  setDiscountInMMK,
  setDiscountInTHB,
  discountInMMK,
  discountInTHB,
  totalInMMK,
  totalInTHB,
  changeInTHB,
  changeInMMK,
  paidAmountInMMK,
  setPaidAmountInMMK,
  paidAmountInTHB,
  setPaidAmountInTHB,
  advancedInMMK,
  advancedInTHB,
  advancedEnabled,
  setAdvancedEnabled,
  taxAmountInMMK,
  taxAmountInTHB,
  setAdvancedInMMK,
  setAdvancedInTHB,
  promotionAmountInMMK,
  promotionAmountInTHB,
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const formatInvoiceAmount = (value, currency) => {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    const numericValue = Number(String(value).replace(/,/g, ""));
    if (!Number.isFinite(numericValue)) {
      return "";
    }

    const maximumFractionDigits = currency === "BAHT" ? 6 : 2;
    const minimumFractionDigits =
      numericValue % 1 === 0 ? 0 : Math.min(2, maximumFractionDigits);

    return numericValue.toLocaleString("en-US", {
      minimumFractionDigits,
      maximumFractionDigits,
    });
  };

  return (
    <section className="invoice-details">
      <div>
        <label>Choose Currency</label>
        <div className="flex invoice-currency-options">
          <label htmlFor="currencyMMK" className="invoice-currency-option">
            <input
              type="radio"
              id="currencyMMK"
              name="currency"
              value="MMK"
              checked={currencyType === "MMK"}
              onChange={(e) => setCurrencyType(e.target.value)}
            />
            <span>MMK</span>
          </label>
          <label htmlFor="currencyTHB" className="invoice-currency-option">
            <input
              type="radio"
              id="currencyTHB"
              name="currency"
              value="BAHT"
              checked={currencyType === "BAHT"}
              onChange={(e) => setCurrencyType(e.target.value)}
            />
            <span>THB</span>
          </label>
          <label htmlFor="currencySep" className="invoice-currency-option">
            <input
              type="radio"
              id="currencySep"
              name="currency"
              value="SEPERATED"
              checked={currencyType === "SEPERATED"}
              onChange={(e) => setCurrencyType(e.target.value)}
            />
            <span>Seperated</span>
          </label>
        </div>
      </div>
      {currencyType !== "SEPERATED" ? (
        <div>
          <label htmlFor="subtotal">Subtotal</label>
          <span id="subtotal">{formatNumberWithCommas(subTotal)}</span>
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="subTotalMMK">Subtotal In MMK</label>
          <span id="subTotalMMK">{formatInvoiceAmount(subTotalMMK, "MMK")}</span>
        </div>
      ) : null}
      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="subTotalTHB">Subtotal In THB</label>
          <span id="subTotalTHB">{formatInvoiceAmount(subTotalTHB, "BAHT")}</span>
        </div>
      ) : null}
      {currencyType !== "SEPERATED" ? (
        <div>
          <label htmlFor="discountAmount">Discount</label>
          <input
            type="text"
            inputMode="decimal"
            id="discountAmount"
            value={formatNumberWithCommas(discount)}
            min={0}
            onChange={(e) => setDiscount(parseNumericValue(e.target.value))}
          />
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="discountInMMK">Discount In MMK</label>
          <input
            type="text"
            inputMode="decimal"
            id="discountInMMK"
            value={formatInvoiceAmount(discountInMMK, "MMK")}
            min={0}
            onChange={(e) => setDiscountInMMK(parseNumericValue(e.target.value))}
          />
        </div>
      ) : null}
      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="discountInTHB">Discount In THB</label>
          <input
            type="text"
            inputMode="decimal"
            id="discountInTHB"
            value={formatInvoiceAmount(discountInTHB, "BAHT")}
            min={0}
            onChange={(e) => setDiscountInTHB(parseNumericValue(e.target.value))}
          />
        </div>
      ) : null}

      {currencyType !== "SEPERATED" ? (
        <div>
          <label htmlFor="promotionAmount">Promotion Amount</label>
          <span id="promotionAmount" className="invoice-value">
            {formatNumberWithCommas(promotionAmount)}
          </span>
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="promotionAmountInMMK">Promotion Amount In MMK</label>
          <span id="promotionAmountInMMK" className="invoice-value">
            {formatInvoiceAmount(promotionAmountInMMK, "MMK")}
          </span>
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="promotionAmountInTHB">Promotion Amount In THB</label>
          <span id="promotionAmountInTHB" className="invoice-value">
            {formatInvoiceAmount(promotionAmountInTHB, "BAHT")}
          </span>
        </div>
      ) : null}

      <div className="flex flex-row">
        <div>
          <label htmlFor="tax">Tax</label>
          <input
            type="checkbox"
            id="tax"
            name="tax"
            value={taxEnabled}
            onChange={(e) => setTaxEnabled(e.target.checked ? 1 : 0)}
          />
        </div>

        <div className=" items-center gap-1">
          <input
            type="number"
            id="taxPercent"
            pattern="^09[0-9]{7,9}$"
            inputMode="numeric"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/[^0-9]/g, "");
              setTax(numericValue);

              const numeric = parseInt(numericValue, 10);

              if (!numericValue) {
                setErrorMessage("Please enter a number.");
              } else if (isNaN(numeric) || numeric > 100) {
                setErrorMessage(
                  "Tax percent must be  greater than 0 or less than 100."
                );
              } else {
                setErrorMessage(""); // Clear message when valid
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            //onChange={e => setTax(parseFloat(e.target.value))}
            min={0}
            max={100}
            value={tax}
          />
          <label htmlFor="taxPercent">%</label>
          {errorMessage && (
            <div className="text-red-500 text-sm mt-1">{errorMessage}</div>
          )}
        </div>
      </div>
      {currencyType !== "SEPERATED" ? (
        <div>
          <label htmlFor="taxAmount">Tax Amount</label>
          <span id="taxAmount">{formatNumberWithCommas(isNaN(taxAmount) ? 0 : taxAmount)}</span>
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="taxAmountInMMK">Tax Amount In MMK</label>
          <span id="taxAmountInMMK">
            {formatInvoiceAmount(isNaN(taxAmountInMMK) ? 0 : taxAmountInMMK, "MMK")}
          </span>
        </div>
      ) : null}
      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="taxAmountInTHB">Tax Amount In THB</label>
          <span id="taxAmountInTHB">
            {formatInvoiceAmount(isNaN(taxAmountInTHB) ? 0 : taxAmountInTHB, "BAHT")}
          </span>
        </div>
      ) : null}

      {
        <div className="flex flex-row">
          <div>
            <label htmlFor="advanced">Adv</label>
            <input
              type="checkbox"
              id="advanced"
              name="advanced"
              value={advancedEnabled}
              onChange={(e) => setAdvancedEnabled(e.target.checked ? 1 : 0)}
            />
          </div>
        </div>
      }

      {(currencyType === "SEPERATED") | (currencyType === "MMK") ? (
        <div>
          <label htmlFor="advancedInMMK">Advanced In MMK</label>
          <input
            type="text"
            inputMode="decimal"
            max={`${advancedInMMK}`}
            id="advancedInMMK"
            disabled={!advancedEnabled}
            value={formatInvoiceAmount(advancedInMMK, "MMK")}
            min={0}
            onChange={(e) => setAdvancedInMMK(parseNumericValue(e.target.value))}
          />
        </div>
      ) : null}
      {(currencyType === "SEPERATED") | (currencyType === "BAHT") ? (
        <div>
          <label htmlFor="advancedInTHB">Advanced In THB</label>
          <input
            type="text"
            inputMode="decimal"
            max={`${advancedInTHB}`}
            id="advancedInTHB"
            disabled={!advancedEnabled}
            value={formatInvoiceAmount(advancedInTHB, "BAHT")}
            min={0}
            onChange={(e) => setAdvancedInTHB(parseNumericValue(e.target.value))}
          />
        </div>
      ) : null}

      {currencyType !== "SEPERATED" ? (
        <div>
          <label htmlFor="totalAmount">Total Amount</label>
          <span id="totalAmount">{formatNumberWithCommas(total)}</span>
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="totalAmount">Total Amount In MMK</label>
          <span id="totalAmount">{formatInvoiceAmount(totalInMMK, "MMK")}</span>
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="totalAmount">Total Amount In THB</label>
          <span id="totalAmount">{formatInvoiceAmount(totalInTHB, "BAHT")}</span>
        </div>
      ) : null}
      {currencyType !== "SEPERATED" ? (
        <div>
          <label htmlFor="paidAmountInMMK">Paid Amount</label>
          <input
            type="text"
            inputMode="decimal"
            value={formatNumberWithCommas(paidAmount)}
            onChange={(e) => setPaidAmount(parseNumericValue(e.target.value))}
          />
        </div>
      ) : null}
      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="paidAmountInMMK">Paid Amount In MMK</label>
          <input
            type="text"
            inputMode="decimal"
            value={formatInvoiceAmount(paidAmountInMMK, "MMK")}
            onChange={(e) => setPaidAmountInMMK(parseNumericValue(e.target.value))}
          />
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="paidAmountInTHB">Paid Amount In THB</label>
          <input
            type="text"
            inputMode="decimal"
            value={formatInvoiceAmount(paidAmountInTHB, "BAHT")}
            onChange={(e) => setPaidAmountInTHB(parseNumericValue(e.target.value))}
          />
        </div>
      ) : null}

      {currencyType !== "SEPERATED" ? (
        <div>
          <label htmlFor="charge">Change</label>
          <span id="charge">{formatNumberWithCommas(change)}</span>
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="charge">Change In MMK</label>
          <span id="charge">{formatInvoiceAmount(isNaN(changeInMMK) ? 0 : changeInMMK, "MMK")}</span>
        </div>
      ) : null}

      {currencyType === "SEPERATED" ? (
        <div>
          <label htmlFor="charge">Change In THB</label>
          <span id="charge">{formatInvoiceAmount(isNaN(changeInTHB) ? 0 : changeInTHB, "BAHT")}</span>
        </div>
      ) : null}
    </section>
  );
};

export default InvoiceDetails;
